// Web shim for react-native-keychain using localStorage

const KEYCHAIN_KEY = '__rn_keychain__';

export async function setGenericPassword(username, password) {
  try {
    localStorage.setItem(KEYCHAIN_KEY, JSON.stringify({ username, password }));
    return true;
  } catch {
    return false;
  }
}

export async function getGenericPassword() {
  try {
    const data = localStorage.getItem(KEYCHAIN_KEY);
    if (data) {
      return JSON.parse(data);
    }
    return false;
  } catch {
    return false;
  }
}

export async function resetGenericPassword() {
  localStorage.removeItem(KEYCHAIN_KEY);
  return true;
}

export default {
  setGenericPassword,
  getGenericPassword,
  resetGenericPassword,
};
